import { useState } from "react";
import styled from "styled-components";
import { InputText, ModalForm, Select } from "@ficatranquilo/contabilidade.com-ui";
import useService from "@hooks/useService";
import { API_KEY_SCOPES, API_KEY_VALIDITIES } from "@helpers/apiKeys";
import { focusFirstError } from "../../Common/FormPage";

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const NAME_ID = "api-key-name";
const NAME_MAX = 255;

/**
 * Gerar uma chave. O texto dela só vem nesta resposta: quem abre o modal recebe em
 * `onCreated(plaintext)`. Em erro, o sendError do service mostra o toast e o modal fica aberto.
 */
export default function ApiKeyFormModal({ onClose, onCreated }) {
  const apiKeysService = useService("apiKeys");
  const [values, setValues] = useState({ name: "", scope: "read", validity: "never" });
  const [submitted, setSubmitted] = useState(false);
  const [saving, setSaving] = useState(false);

  const nameError = submitted && !values.name.trim() ? "Informe um nome para a chave." : undefined;
  const set = (field, value) => setValues((prev) => ({ ...prev, [field]: value }));

  function close() {
    if (!saving) onClose();
  }

  async function save() {
    setSubmitted(true);
    if (!values.name.trim()) {
      focusFirstError([NAME_ID]);
      return;
    }

    setSaving(true);
    const result = await apiKeysService.generate({
      name: values.name.trim(),
      scope: values.scope,
      expiresInDays: API_KEY_VALIDITIES.find((option) => option.value === values.validity).days,
    });
    setSaving(false);
    if (!result || result.error) return;
    onCreated(result.data?.plaintext);
  }

  return (
    <ModalForm
      $showModal
      $setShowModal={close}
      $noClose={saving}
      $isLoading={saving}
      $size="medium"
      $title="Gerar nova chave de API"
      $contentBackground="N0"
      $actions={[
        { text: "Cancelar", action: close, variant: "outline", isDisabled: saving },
        { text: "Gerar chave", action: save, variant: "primary", isDisabled: saving },
      ]}
    >
      <Stack>
        <InputText
          $idForm={NAME_ID}
          $label="Nome"
          $variant="default"
          $hasTooltip="Usado apenas para você identificar a chave."
          $errors={nameError}
          maxLength={NAME_MAX}
          placeholder="Ex.: Integração ERP"
          value={values.name}
          onChange={(e) => set("name", e.target.value)}
        />
        <Select
          $idForm="api-key-scope"
          $label="Escopo"
          $options={API_KEY_SCOPES}
          value={API_KEY_SCOPES.find((option) => option.value === values.scope)}
          onChange={(option) => set("scope", option.value)}
        />
        <Select
          $idForm="api-key-validity"
          $label="Validade"
          $options={API_KEY_VALIDITIES}
          value={API_KEY_VALIDITIES.find((option) => option.value === values.validity)}
          onChange={(option) => set("validity", option.value)}
        />
      </Stack>
    </ModalForm>
  );
}
